<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { formatNumber } from '@chatwoot/utils';

const props = defineProps({
  folders: { type: Array, default: () => [] },
  activeFolderId: { type: [Number, String], default: 0 },
  allCount: { type: Number, default: 0 },
  folderCounts: { type: Object, default: () => ({}) },
});

defineEmits(['selectAll', 'selectFolder']);

const { t } = useI18n();

const isAllActive = computed(() => !Number(props.activeFolderId));

const isFolderActive = id => Number(props.activeFolderId) === id;

const chipClass = active =>
  active
    ? 'bg-[#3cbeb6] text-white'
    : 'bg-n-alpha-1 text-n-slate-11 hover:bg-n-alpha-2';
</script>

<template>
  <div class="flex items-center gap-2 px-4 py-2 overflow-x-auto">
    <button
      type="button"
      class="flex items-center gap-1.5 px-3 py-1 text-xs font-medium rounded-full shrink-0 transition-colors"
      :class="chipClass(isAllActive)"
      @click="$emit('selectAll')"
    >
      <span>{{ t('CHAT_LIST.CHAT_STATUS_FILTER_ITEMS.all.TEXT') }}</span>
      <span v-if="allCount > 0" class="opacity-70">
        {{ formatNumber(allCount) }}
      </span>
    </button>

    <button
      v-for="folder in folders"
      :key="folder.id"
      type="button"
      class="flex items-center gap-1.5 px-3 py-1 text-xs font-medium rounded-full shrink-0 transition-colors max-w-[160px]"
      :class="chipClass(isFolderActive(folder.id))"
      :title="folder.name"
      @click="$emit('selectFolder', folder.id)"
    >
      <span class="truncate">{{ folder.name }}</span>
      <span v-if="folderCounts[folder.id] > 0" class="opacity-70">
        {{ formatNumber(folderCounts[folder.id]) }}
      </span>
    </button>
  </div>
</template>
